<template>
  <Scrollbar :show_bar="true" class="collection-product-history-box" v-show="props.openHistoryVal">
    <loading v-if="is_loading" />
    <div v-else>
      <div class="section">
        <div class="small-header">
          <h3>Activity</h3>
          <svg-icon name="history-menu" @click="emit('handleOpenHistort')" />
        </div>
        <ActivityItem
          v-if="activityObj"
          :data="activityObj"
          @request-update="openMessagePopup"
          @view-message="goMessage"
        />
      </div>

      <div class="hr"></div>
      <div class="section">
        <h3>History</h3>
        <ActivityItem
          v-for="(item, index) in historyList"
          :key="'history-' + index"
          :data="item"
          @request-update="openMessagePopup"
          @view-message="goMessage"
        />
      </div>
    </div>
  </Scrollbar>
  <el-dialog title="Follow up" width="480" v-model="is_open_message_popup" @close="closeMessagePopup" class="send-message-dialog" :class="{'is-sending' : is_sending}">
    <div class="input-item">
        <label for="comments">Comment</label>
        <el-input v-model="message" maxlength="200" rows="6" placeholder="Explain why you’re changing this post’s status." show-word-limit type="textarea" resize="none" />
    </div>
    <div class="btn-row">
        <el-button @click="closeMessagePopup">Cancel</el-button>
        <el-button type="primary" @click="sendMessage()" :disabled="!message">Confirm and send</el-button>
    </div>
  </el-dialog>
</template>

<script setup>

import { ref, getCurrentInstance, onMounted, onBeforeUnmount } from 'vue';
// import { useRouter } from 'vue-router';
// import { useStore } from 'vuex';
import moment from 'moment';
// import Store from '@/store/index.js';
import { ElDialog, ElButton, ElInput } from 'element-plus';
import { useNotification } from '@/components/ui/notification';
import { useCollectionFilter } from '@/components/creator/collectionFilterFunction.js';
import Loading from '@/components/ui/Loading.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import ActivityItem from './ActivityHistoryItem.vue';

// const router = useRouter();
// const store = useStore();
const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const { openNotBottom } = useNotification();
const { makeHistoryTitle, makeHistoryColor, callApiTypeId, canViewMessage, specialReson } = useCollectionFilter();

const props = defineProps({
  openHistoryVal: {
    type: Boolean,
    default: false
  },
  type: {
    type: String,
    default: 'post' // or 'collection'
  },
  contentId: {
    type: Number,
    default: 0
  },
  user_name:{
    type: String,
    default: ''
  },
  user:{
    type: Object,
    default: null
  }
});

const emit = defineEmits(['handleOpenHistort', 'handleCloseModel','handleOpenHistortValue']);

const eventBus = app.appContext.config.globalProperties.EventBus;
const activityObj = ref(null);
const historyList = ref([]);
const is_loading = ref(false);
const message = ref('');
const content_moderation_item = ref(null);
const is_open_message_popup = ref(false);
const is_sending = ref(false);

//++++++++++++++++++++++++++++++++++++++++
// 共用處理函數
const decorateItem = (item, type, user_name) => {
  return {
    clientTitle: makeHistoryTitle(item, type, user_name),
    clientDate: moment(item.created_at).format('MMM DD, hh:mm A'),
    color: makeHistoryColor(item),
    viewMessage: canViewMessage(item),
    reason: item.reason,
    sepc_reason: specialReson(item),
    only_title: item.operate_type !== 10 && item.operate_type !== 20 && item.operate_type !== 30,
    ...item,
    // 如果有 activity_list，遞迴處理
    activity_list: item.activity_list?.map(child =>
      decorateItem(child, type, user_name)
    )
  };
};

const openMessagePopup = (item) => {
  content_moderation_item.value = item;
  is_open_message_popup.value = true;
};

const closeMessagePopup = () => {
  content_moderation_item.value = null;
  is_open_message_popup.value = false;
};

const sendMessage = () => {
  if (!message.value) {
    return;
  }
  is_sending.value = true;

  // setTimeout(() => {
  //   openNotBottom('Submitted.', 'success');
  //   closeMessagePopup();
  //   is_sending.value = false;
  // }, 1000);
  ajax.post('/creator/response-message-to-creator', {
    content_moderation_history_id: content_moderation_item.value.id.toString(),
    reason: message.value
  }).then((res) => {
    // openNotBottom('Success', 'Message sent successfully.');
    is_open_message_popup.value = false;
    message.value = '';
    callHistory();
  }).catch(err => {
    console.error('Failed to send follow-up message:', err);
    // openNotBottom('Error', 'Failed to send message. Please try again.');
    is_loading.value = false;
  });
};

const callHistory = () => {
  is_loading.value = true;
  activityObj.value = null;
  historyList.value = [];
  ajax.get(`/creator/get-content-moderation-detail?content_id=${props.contentId}&content_type=${callApiTypeId(props.type)}`).then((res) => {
    emit('handleOpenHistortValue', res.data.data.content_moderation)
    //act
    activityObj.value = res.data.data.activity;
    if(activityObj.value){
      activityObj.value = decorateItem(activityObj.value, props.type, props.user_name);
    }
    //history
    historyList.value = res.data.data.history
      .sort((a, b) => new Date(b.updated_at) - new Date(a.updated_at))
      .map(item => decorateItem(item, props.type, props.user_name));
    
    // console.log('historyList',historyList.value)
    is_loading.value = false;
  }).catch(err => {
    console.error('Failed to fetch content flag list:', err);
    is_loading.value = false;
  });
};


const goMessage = (val) => {
  props.user.creator_portal_user_id = val.creator_portal_user_id;
  props.user.first_name = props.user_name;
  props.user.last_name = '';

  // add message to url
  const url = new URL(window.location);
  url.searchParams.set('message_id', val.message_id);
  window.history.replaceState(null, '', url.toString());
  eventBus.emit('open-chat', props.user)
}

onMounted(() => {
  callHistory();
});

// onBeforeUnmount(() => {

// });

</script>

<style lang="scss">
.collection-product-history-box {
  padding: 16px 0 16px 16px;
  border-left: solid 1px var(--border);
  min-width: 200px;
  max-height: calc(100vh - 56px);

  .section {
    margin-bottom: 24px;

    .small-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-bottom: 16px;
      border-bottom: 1px solid var(--border);

      .svg-icon {
        cursor: pointer;
        width: 22px;
        height: 22px;
        fill: var(--text-secondary);
      }
    }

    h3 {
      font: var(--font-med-16);
    }

    .activity-item {
      border-left: 3px solid transparent;
      padding: 0 12px 0px 16px;
      margin: 16px 0;
      position: relative;

      .hr {
        width: 100%;
        height: 1px;
        border-bottom: solid 1px var(--border);
      }

      &.red {
        border-color: var(--red); // red
      }

      &.yellow {
        border-color: var(--yellow);
      }

      &.blue {
        border-color: var(--blue); // blue
      }

      &.green {
        border-color: var(--green); // green
      }

      &.normal {
        border-color: var(--black-50);
      }
      &.normal-small,
      &.gray {
        border-color: var(--black-20);
      }

      .meta {
        display: grid;
        gap: 4px;
        margin: 8px 0;

        time {
          font-size: 14px;
          color: var(--black-50);
        }

        h4 {
          font-size: 14px;
          .strong-span{
            font: var(--font-med-14);
          }
        }

        .content {
          font-size: 14px;
          color: var(--text-secondary);
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }

        .a-go {
          font-size: 14px;
          color: var(--blue);
          text-decoration: none;
          cursor: pointer;
        }
      }

    }

    .act-other-list{
      margin-left: 2px;
    }
  }
}

.send-message-dialog {
  label {
    font: var(--font-med-14);
    margin-bottom: 6px;
    display: block;
    color: var(--black-90);

    &:after {
      content: '*';
      color: var(--red);
      margin-left: 2px;
    }
  }

  .btn-row {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;

    .el-button {
      margin-left: 8px;
    }
  }

  &.is-sending {
    .el-input {
      opacity: 0.5;
    }

    .el-button {
      opacity: 0.5;

      &:not(.is-loading) {
        cursor: not-allowed;
      }
    }
  }
}
</style>